import ExcelJS from 'exceljs';
import { format } from 'date-fns';

export type ChartDataRow = Record<string, string | number | null>;

export type GraphData = {
  name: string;
  data: Array<ChartDataRow>;
  columns: Array<string>;
};

export const downloadExcel = async (graphs: Array<GraphData>, tabName: string) => {
  const workbook = new ExcelJS.Workbook();
  const timestamp = format(new Date(), 'yyyy_MM_dd');

  for (const graph of graphs) {
    const worksheet = workbook.addWorksheet(graph.name.substring(0, 31));

    const headerRow = worksheet.addRow(graph.columns);
    headerRow.font = { bold: true };
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E0E0' },
    };

    graph.data.forEach((row) => {
      const rowData = graph.columns.map((col) => {
        const value = row[col];
        if (value === null || value === undefined) return '';
        return value;
      });
      worksheet.addRow(rowData);
    });

    graph.columns.forEach((_, index) => {
      const column = worksheet.getColumn(index + 1);
      let maxLength = 10;
      column.eachCell?.({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? String(cell.value) : '';
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = Math.min(maxLength + 2, 50);
    });
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${tabName}_${timestamp}.xlsx`;
  link.click();
  URL.revokeObjectURL(link.href);
};
